<template>
  <div id="app">


    <!--<router-link to="/auto/contract">Go to contract</router-link>-->

    <!--        <img alt="Vue logo" src="./assets/logo.png">-->

    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
/* Import Bootstrap Vue Styles */
@import "assets/Styles/styles.css";
@import '~bootstrap-vue/dist/bootstrap-vue.min.css';
@import "~bootstrap/dist/css/bootstrap.min.css";

@font-face {
  font-family: FiraGo;
  src: url("assets/fonts/FiraGO-Regular.woff");
}
* {
  font-family: FiraGo, serif;
}
/*#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    !*margin-top: 60px;*!
}*/
</style>
